import * as Actions from '../Actions/AgendaPainelActions';

const initialState = {
    open: false,
    data: null,
    tipos: null,
    preload: false,
};

const AgendaPainel = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_AGENDA_PAINEL:
            {
                return {
                    ...state,
                    data: action.payload,
                    preload: false,
                };
            }
        case Actions.GET_AGENDA_PAINEL_TIPOS:
            {
                return {
                    ...state,
                    tipos: action.payload,
                    preload: false,
                };
            }
        case Actions.TOGGLE_AGENDA_PAINEL:
            {
                return {
                    ...state,
                    open: !state.open,
                    preload: false,
                };
            }
        case Actions.AGENDA_PAINEL_CHANGE_PRELOAD:
            {
                return {
                    ...state,
                    preload: action.preload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default AgendaPainel;
